import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { spaceXXL } from '@xing-com/tokens';

const StyledFrame = styled.iframe`
  width: 728px;
  height: 90px;
  border: 0;
  margin: ${spaceXXL};
`;
type IframeTypes = {
  trackingParams: {
    page: string;
    sentBy: string;
  };
};

export const DisplayAdLoginLeaderboardIframeSlot: React.FC<IframeTypes> = ({
  trackingParams,
}) => {
  const { sentBy, page } = trackingParams;

  const isBigScreen = useMatchMedia(
    '(min-width: 1584px) and (min-height: 900px)'
  );

  if (!isBigScreen) {
    return null;
  }

  return (
    <NoSSR>
      <StyledFrame
        src={`/reklame/iframe?sentBy=${encodeURIComponent(sentBy)}&page=${encodeURIComponent(page)}`}
        title="Reklame frame"
        sandbox="allow-scripts allow-same-origin allow-popups"
        scrolling="no"
      />
    </NoSSR>
  );
};
